class PricingSlider {
  constructor() {
    this.pricingSlider = $("#js-pricingSlider")
    if (this.pricingSlider.length > 0) {
      this.load()
    }
  }

  load() {
    const priceOutput = $("#js-price_output")
    const usersCountOutput = $("#js-users_count_output")
    const pricingPlan = new Object()

    pricingPlan["base"] = {
      min: 0,
      max: 10,
      price: 3,
    }
    pricingPlan["medium"] = {
      min: 10,
      max: 20,
      price: 2,
    }
    pricingPlan["premium"] = {
      min: 20,
      max: null,
      price: 1,
    }

    var priceSimulation = function (signaturesAmount) {
      let totalPrice = 0

      Object.keys(pricingPlan).forEach(function (planName) {
        if (pricingPlan[planName].min > signaturesAmount) {
          // Skip plan if minimum greater than signaturesAmount
        } else {
          if (pricingPlan[planName].max === null) {
            totalPrice +=
              (signaturesAmount - pricingPlan[planName].min) *
              pricingPlan[planName].price
          } else if (signaturesAmount <= pricingPlan[planName].max) {
            totalPrice +=
              (signaturesAmount - pricingPlan[planName].min) *
              pricingPlan[planName].price
          } else if (signaturesAmount >= pricingPlan[planName].max) {
            totalPrice +=
              (pricingPlan[planName].max - pricingPlan[planName].min) *
              pricingPlan[planName].price
          }
        }
      })
      return totalPrice
    }

    var showPrice = function (signaturesAmount) {
      var totalPrice = priceSimulation(signaturesAmount)
      priceOutput.html(totalPrice)
      usersCountOutput.html(signaturesAmount)
    }

    var showCompanyIllustration = function (signaturesAmount) {
      var imageDiv = $("#illustration-company-size")
      imageDiv.removeClass("startup small-company pme large-company")

      switch (true) {
        case signaturesAmount <= 50:
          imageDiv.addClass("startup")
          break
        case signaturesAmount <= 100:
          imageDiv.addClass("small-company")
          break
        case signaturesAmount <= 300:
          imageDiv.addClass("pme")
          break
        case signaturesAmount <= 500:
          imageDiv.addClass("large-company")
          break
      }
    }

    var paidSignaturesAmount = function (realSignaturesAmount) {
      if (realSignaturesAmount > 5) {
        var _paidSignaturesAmount =
          realSignaturesAmount - (realSignaturesAmount % 5)
        return _paidSignaturesAmount
      } else {
        return realSignaturesAmount
      }
    }

    this.pricingSlider.on("input", function (slider) {
      var signaturesAmount = paidSignaturesAmount(slider.target.value)

      showPrice(signaturesAmount)
      showCompanyIllustration(signaturesAmount)
    })

    this.pricingSlider.children(".slider")[0].value = 70
    var paidSignatures = paidSignaturesAmount(
      this.pricingSlider.children(".slider")[0].value
    )

    showPrice(paidSignatures)
    showCompanyIllustration(paidSignatures)
  }
}
export { PricingSlider }
